import { put } from 'redux-saga/effects';
import sign from './sign';
import { loadFileByUrl, uploadFile } from '../actions';

export default function* signFile(certData, file, detached = true) {
  const loadFilePromise = yield put(loadFileByUrl(file.url));
  const fileBlob = yield loadFilePromise;
  const signature = yield sign(certData, fileBlob, true);
  if (typeof signature === 'string') {
    throw new Error(signature);
  }
  const formData = new FormData();
  formData.append('model_type', file.model_type);
  formData.append('model_id', file.model_id);
  formData.append('collection_name', `${file.collection_name}_sig`);
  formData.append('name', file.name);
  formData.append('file', signature, `${file.name}.sig`);
  const fileUploadPromise = yield put(uploadFile(formData));
  const fileUpload = yield fileUploadPromise;
  if (!fileUpload) {
    throw new Error(`Фаил «${file.name}.sig» не сохранен`);
  }
  return true;
}
